import httpStatus from "http-status";
import apiConfig from "./apiConfig";
 

async function callApi(apiObject) {
  const fetchObject = {};
  fetchObject.method = apiObject.method ? apiObject.method : "GET";
  if (fetchObject.method !== 'GET'){

   
   fetchObject.body = apiObject.body ? JSON.stringify(apiObject.body) : {};
 }
  fetchObject.headers = {
    Accept: "application/json",
    "Content-Type": "text/plain; charset=UTF-8"
  };
  if (apiObject.authentication) {
    fetchObject.headers.Authorization = apiObject.authentication;
  }
  
  console.log(apiObject.Authorization)
 
  const url = `${apiConfig.serverUrl}/${apiObject.endpoint}`;
  console.log(url)
  const fetchResult = await fetch(url, fetchObject);
  return new Promise(async (resolve, reject) => {
     if (
      fetchResult.status >= httpStatus.OK &&
       fetchResult.status <= httpStatus.MULTIPLE_CHOICES
    ) {
      console.log("fetchResult")
      console.log(fetchResult)
      return resolve(fetchResult.json());
    }
    const errorResponse = await fetchResult.json();
    return reject(errorResponse);
  });
}

export  {callApi};
